import styled from "styled-components/macro"
import { ReactComponent as RoundCheckSVG } from "../assets/round-check.svg"
import { ReactComponent as RoundCrossSVG } from "../assets/round-cross.svg"
import { colors } from "../styles/design.config"
import * as Ct from "ldlj"

export interface RowPermissionProps {
  isAuthorized?: boolean
  text: string
}

export const RowPermission = ({
  isAuthorized = true,
  text,
}: RowPermissionProps) => (
  <Row>
    <SVG>{isAuthorized ? <RoundCheckSVG /> : <RoundCrossSVG />}</SVG>
    <Ct.Spacer width={1} />
    <Permission isAuthorized={isAuthorized}> {text} </Permission>
  </Row>
)

interface Authorized {
  isAuthorized: boolean
}

const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`

const Permission = styled.div<Authorized>`
  display: flex;
  color: ${({ isAuthorized }) =>
    isAuthorized ? `${colors.navy}` : `${colors.hawkes}`};
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 1.75rem;
  line-height: 3.25rem;
  flex-wrap: nowrap;
  flex-shrink: 0;
`

const SVG = styled.div`
  display: flex;
`
